const DateConfig = {
  MinDate: new Date(0),
  MaxDate: new Date("2222-12-31"),
};
export default DateConfig;
